import React from 'react';
export function Ingredients() {
  const activeIngredients = [{
    name: 'Menthol',
    benefit: 'Provides cooling comfort and helps reduce discomfort signals'
  }, {
    name: 'Capsaicin',
    benefit: 'Creates warming sensation and helps quiet overactive nerve signals'
  }];
  const deliveryIngredients = [{
    name: 'Borneol',
    benefit: 'Natural compound that enhances skin penetration'
  }, {
    name: 'Azone',
    benefit: 'Helps actives reach deeper tissue layers'
  }];
  const herbalIngredients = [{
    name: 'Ginger Extract',
    benefit: 'Traditional comfort herb that supports circulation'
  }, {
    name: 'Artemisia',
    benefit: 'Herbal extract with soothing properties'
  }, {
    name: 'Camphor',
    benefit: 'Provides cooling sensation and temporary relief to affected areas'
  }];
  return <section className="py-12 bg-white" data-id="element-216">
      <div className="container mx-auto px-4" data-id="element-217">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-8 text-[#0E6B6B]" data-id="element-218">
          Ingredients That Matter
        </h2>
        <div className="max-w-3xl mx-auto" data-id="element-219">
          <h3 className="text-xl font-bold mb-4" data-id="element-220">Key Active Ingredients</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-221">
            {activeIngredients.map((ingredient, index) => <div key={index} className="bg-[#EAF7F3] p-4 rounded-lg" data-id="element-222">
                <h4 className="font-bold text-[#0E6B6B]" data-id="element-223">{ingredient.name}</h4>
                <p data-id="element-224">{ingredient.benefit}</p>
              </div>)}
          </div>
          <h3 className="text-xl font-bold mb-4" data-id="element-225">Delivery Duo</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-226">
            {deliveryIngredients.map((ingredient, index) => <div key={index} className="bg-[#EAF7F3] p-4 rounded-lg" data-id="element-227">
                <h4 className="font-bold text-[#0E6B6B]" data-id="element-228">{ingredient.name}</h4>
                <p data-id="element-229">{ingredient.benefit}</p>
              </div>)}
          </div>
          <h3 className="text-xl font-bold mb-4" data-id="element-230">Herbal Comfort Complex</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-231">
            {herbalIngredients.map((ingredient, index) => <div key={index} className="bg-[#EAF7F3] p-4 rounded-lg" data-id="element-232">
                <h4 className="font-bold text-[#0E6B6B]" data-id="element-233">{ingredient.name}</h4>
                <p data-id="element-234">{ingredient.benefit}</p>
              </div>)}
          </div>
          <div className="text-center" data-id="element-235">
            <p className="text-sm mb-2" data-id="element-236">
              Formulated at effective, skin-friendly levels.
            </p>
          </div>
        </div>
      </div>
    </section>;
}